import React, {Component} from 'react'
import {connect} from 'react-redux'
import Grid from '../grid/Grid'
import {getColumns as getColumnsAudit, getExpandRowDef } from '../audit/Audits'
import Loading from '../Loading'
import {getSelectFilterCfg} from '../grid/ColumnHelpers'

const getColumns = ({kodif, metadata, user}) => {
    const auditColumns = getColumnsAudit({kodif, metadata})
    const atrCol = auditColumns.find(c => c.dataField === 'atradnes')
    atrCol.filterCfg = undefined
    if (!user.tiesibas.includes('SKATIT_ATRADNES_AUDITU')) {
        const viewNameCol = auditColumns.find(c => c.dataField === 'view_name')
        viewNameCol.filterCfg = getSelectFilterCfg({
            izmaina_view: {nos: 'Krājumu izmaiņas'},
            izmaina_view_grouped: {nos: 'Krājumu izmaiņas (grupēti)'}
        })
    }
    return auditColumns
}

class AtradnesVesture extends Component {

    render() {

        const {metadata, user} = this.props

        if (!metadata.loaded) {
            return (<Loading/>)
        }

        if(!this.columns){
            this.columns = getColumns({
                kodif: this.props.kodif,
                metadata,
                user
            })
        }

        if(!this.expandRow){
            this.expandRow = getExpandRowDef({
                metadata
            })
        }

        const {loading, list, count} = this.props.atradnesVesture

        return (
            <div className="saraksts-wrapper">
                <Grid
                    loading={loading}
                    dataList={list}
                    totalCount={count}
                    columns={this.columns}
                    expandRow={this.expandRow}
                />
            </div>
        )
    }
}

const mapStateToProps = ({atradnesVesture, kodif, metadata, user}) => ({atradnesVesture, kodif, metadata, user})
export default connect(mapStateToProps)(AtradnesVesture)

const mapStateToPropsDala = ({atradnesDalasVesture, kodif, metadata, user}) => ({atradnesVesture: atradnesDalasVesture, kodif, metadata, user})
export const AtradnesVestureDala =  connect(mapStateToPropsDala)(AtradnesVesture)